import React, {useState} from 'react';
import clsx from "clsx";

/**
 * 2022-01 copy predefined text to clipboard
 *
 *  2026 modernized. Used only for agent cart indicator on view cart  page
 */

export default function TextToClipboard({
  caption,
  text,
  message, // optional message to display after copying
  icon = 'fa fa-copy',
  successIcon = 'fa fa-check'
}) {

  const [copied, setCopied] = useState(false);

  const handleClick = (evt) => {
    evt?.preventDefault();

    copyToClipboard(text).then((r) => {
      setCopied(true);
      if (message)
        alert(message);
    }).catch(err => alert("error: " + err))
  }

  return (
    <a className={""} onClick={handleClick}>
      {caption && <span className="caption">{caption}</span>}
      {' '}
      <span className={clsx([
        copied ? successIcon : icon,
        copied ? 'text-green-500' : ''
      ])
      }/>
    </a>
  );
}

function copyToClipboard(text) {

  const {navigator = {}} = globalThis;
  const {clipboard} = navigator;

  if (!clipboard || !clipboard.writeText) {
    alert("Unable to write to your system clipboard.\nPlease check permissions using the padlock icon next to the address at the top of your browser.")
    return false;
  }

  return clipboard.writeText(text); // Promise
}





